// @ts-check
/**
 * This module adds a `respec` object to the `document` with the following
 * readonly properties:
 *  - version: returns version of ReSpec Script.
 *  - ready: returns a promise that settles when ReSpec finishes processing.
 *  - worker: returns a promise that resolves to the ReSpec Web Worker.
 *
 */
import { serialize } from "../core/exporter.js";
import { sub } from "./pubsubhub.js";
import { workerPromise } from "./worker.js";

export const name = "core/respec-global";

class ReSpec {
  constructor() {
    /** @type {Promise<void>} */
    this._respecDonePromise = new Promise(resolve => {
      sub("end-all", () => resolve(), { once: true });
    });

    /** @type {any[]} */
    this.errors = [];
    /** @type {any[]} */
    this.warnings = [];

    sub("error", (/** @type {any} */ rsError) => {
      console.error(rsError, rsError.toJSON());
      this.errors.push(rsError);
    });
    sub("warn", (/** @type {any} */ rsError) => {
      console.warn(rsError, rsError.toJSON());
      this.warnings.push(rsError);
    });
  }

  get version() {
    return window.respecVersion;
  }

  get ready() {
    return this._respecDonePromise;
  }

  get worker() {
    return workerPromise;
  }

  async toHTML() {
    return serialize("html", document);
  }
}

export function init() {
  const respec = new ReSpec();
  Object.defineProperty(document, "respec", { value: respec });
}
